import React from 'react'
import Layout from '../layout/Layout'
import { useNavigate } from 'react-router-dom'
import moment from 'moment';

export default function EtfModel({ setIsWealthXActive }) {
    const navigate = useNavigate();

    return (
        <Layout>
            <section id="user-portfolio" class="py-4 d-none">
                <div class="container">
                    <div class="row g-3 align-items-center mb-5">
                        <div class="col-md-12">
                            <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                        </div>
                        <div class="col-md-8">
                            <div class="mb-3">
                                <h4 class="mb-0 fw-bold">ETF Portfolio</h4>
                                <small class="fw-normal text-muted">EP ETF Portfolio</small>
                            </div>

                            <p>
                                Subscribe To WealthX to View recommended  ETFs
                            </p>
                            <div class="row g-3 align-items-center d-none">
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Allocated Fund</small>
                                    <h4 class="mb-0">2,00,000</h4>
                                </div>
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Utilized <small class="text-muted">(98%)</small></small>
                                    <h4 class="mb-0">1,98,000</h4>
                                </div>
                                {/* <!-- <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Available Funds</small>
                                    <h4 class="mb-0">25,000</h4>
                                </div> -->
                                <!-- <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Current Value</small>
                                    <h4 class="mb-0">1,80,000</h4>
                                </div>
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Overall P&L</small>
                                    <div class="d-flex align-items-baseline gap-2">
                                        <h4 class="text-success mb-0">+5,000</h4>
                                        <small class="text-success">(+7.5%)</small>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Day's P&L</small>
                                    <div class="d-flex align-items-baseline gap-2">
                                        <h4 class="text-success mb-0">+500</h4>
                                        <small class="text-success">(+0.75%)</small>
                                    </div>
                                </div> --> */}
                            </div>
                            <button class="btn btn-dark" onClick={() => { window.open("https://equitypandit.in/pricing", "_blank"); localStorage.removeItem("selectedPortfolio"); }}>Subscribe Now</button>

                        </div>
                        {/* <!-- Pie chart --> */}
                        <div class="col-md-2 col-6">
                            <div class="d-flex justify-content-center">
                                {/* <!-- <div class="ratio ratio-1x1"> -->
                                    <canvas id="portfolioPieChart"></canvas>
                                    <!-- </div> --> */}
                            </div>
                        </div>
                        {/* <!-- Legend --> */}
                        <div class="col-md-2 col-6">
                            <div id="portfolioPieLegend" class="pie-legend ms-md-2 my-3 mt-md-0"></div>
                        </div>
                    </div>

                    <ul class="nav nav-underline border-bottom mb-3 d-none" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Open</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link " id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Closed</button>
                        </li>
                    </ul>

                    <div class="tab-content d-none" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                            <div class="d-flex align-items-baseline">
                                <h5 class="mb-1 fw-bold">Open Recommendations</h5>
                                <small class="text-muted ms-3">As on 22 Dec, 2025</small>
                            </div>

                            <p>You can add these ETFs to your portfolio now - before they zoom out.</p>

                            {/* <!-- Table header (desktop) --> */}
                            <div class="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                                <div class="row g-3">
                                    <div class="col-md-3">
                                        <span>Scrip</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <span>Recommended Investment</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <span>Recommended Price</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <span>CMP</span>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Rows -->
                            <?php foreach ($rows as $index => $row): ?> */}
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                                <div class="row g-3 align-items-center">
                                    <div class="col-md-3 col-4">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="">
                                                <i class="fa fa-circle fa-2xs" style={{ "color": "black" }}></i> <span style={{ "filter": "blur(5px)" }}>symbol</span>
                                                <small class="d-block">
                                                    <small class="text-muted d-block">
                                                        <i class="fa fa-briefcase"></i> recomQty Units
                                                    </small>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-8">
                                        <div class="text-end">
                                            <small><small class="d-block d-md-none text-muted">Recommended Investment</small></small>
                                            <span class="">invested</span>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        <div class="text-start text-md-end">
                                            <small><small class="d-block d-md-none text-muted">Recommended Price</small></small>
                                            <span>avgPrice</span>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        <div class="text-end">
                                            <small class="d-block"><small class="d-block d-md-none text-muted">CMP</small></small>
                                            <span class="<?= $row['pnlClass'] ?> d-block">ltp</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <?php endforeach; ?> */}
                        </div>
                        <div class="tab-pane fade " id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="d-flex align-items-baseline">
                                        <h5 class="my-3 fw-bold">Closed Recommendations</h5>
                                        <small class="text-muted">As on 22 Dec, 2025</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex justify-content-md-end justify-content-between gap-3 mb-3">
                                        <div class="me-4 d-none">
                                            <small class="text-muted mb-1 d-block">Select Month</small>
                                            <select class="form-select" aria-label="Default select example">
                                                <option selected>- Select -</option>
                                                <option value="1">Nov 2025</option>
                                                <option value="2">Oct 2025</option>
                                                <option value="3">Sep 2025</option>
                                            </select>
                                        </div>
                                        <div class="">
                                            <small class="text-muted mb-1 d-block">Total Booked P&L</small>
                                            <h3 class="fw-bold text-success">+50,725</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Table header (desktop) --> */}
                            <div class="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                                <div class="row g-3">
                                    <div class="col-md-2">
                                        <span>Scrip</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Dates</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Invested & Booked</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Entry & Exit</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Range</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Booked P&L</span>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Rows -->
                            <?php foreach ($rows as $index => $row): ?> */}
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                                <div class="row g-3 align-items-center">
                                    <div class="col-md-2 col-6">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="">
                                                <i class="fa fa-circle fa-2xs" style={{ "color": "black" }}></i> symbol
                                                <small class="d-block">
                                                    <small class="text-muted d-block">
                                                        <i class="fa fa-briefcase"></i> recomQty
                                                    </small>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-end">
                                            <span class="d-block"><small><small class="text-muted">Entry</small></small> 10 Dec, 2025</span>
                                            <span class="d-block"><small><small class="text-muted">Exit</small></small> 17 Dec, 2025</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-start text-md-end">
                                            <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                            <span class="">invested</span>
                                            <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Booked</small></small>
                                            <span class="<?= $row['pnlClass'] ?>">currentValue</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-end">
                                            <small><small class="d-block d-md-none text-muted">Entry</small></small>
                                            <span>avgPrice</span>
                                            <small class="d-block"><small class="d-block d-md-none text-muted">Exit</small></small>
                                            <span class="<?= $row['pnlClass'] ?> d-block">ltp</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-start text-md-end">
                                            <small><small class="d-block d-md-none text-muted">Range</small></small>
                                            avg - ltp
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-end">
                                            <small><small class="d-block d-md-none text-muted">Booked P&L</small></small>
                                            <span class="<?= $row['pnlClass'] ?>">pnl<br class="d-none d-md-block" />
                                                <small><small class="">(+8.75%) pnlIcon</small></small>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/* <?php endforeach; ?> */}
                        </div>
                    </div>

                </div>

                {/* <!-- Modal --> */}
                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                    <div class="modal-dialog modal-sm">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="exampleModalLabel">Edit Average Price</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="d-flex justify-content-between gap-3">
                                    <div>
                                        <small>Scrip</small>
                                        <p class="fw-bold">SBIN</p>
                                    </div>
                                    <div>
                                        <small>Current Avg. Price</small>
                                        <p class="fw-bold">2498.85</p>
                                    </div>
                                </div>
                                <div class="form-floating">
                                    <input type="number" class="form-control fw-bold" id="floatingInput" placeholder="Enter New Avg. Price" />
                                    <label for="floatingInput">Enter New Avg. Price</label>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Modal --> */}

            </section>
            <section id="user-portfolio" class="py-4">
        <div class="container">
            <div class="row justify-content-center justify-content-md-between g-3 align-items-center mb-5">
                <div class="col-md-12">
                    <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                </div>

                <div class="col-md-8">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-12">
                            <div class="d-flex justify-content-start align-items-start gap-3">
                                <div>
                                    <h4 class="mb-1 fw-bold">ETF Portfolio</h4>
                                    <small class="fw-normal text-muted"><span style={{"filter":"blur(5px)"}}>XX</span>% Allocation</small>
                                </div>
                                <button class="btn btn-sm btn-dark" onClick={() => { window.open("https://equitypandit.in/pricing", "_blank"); localStorage.removeItem("selectedPortfolio"); }}><i class="fa fa-unlock"></i> Unlock Now</button>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Invested</small>
                            <h4 class="mb-0" style={{"filter":"blur(5px)"}}>XX,XX,XXX</h4>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Current Value</small>
                            <h4 class="mb-0" style={{"filter":"blur(5px)"}}>XX,XX,XXX</h4>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Current P&L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>+X,XX,XXX</h4><small class="text-success" style={{"filter":"blur(5px)"}}>(+xx.xx%)</small>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Day's P&L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>+X,XXX</h4><small class="text-success" style={{"filter":"blur(5px)"}}>(+xx.xx)</small>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Booked P&amp;L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>X,XX,XXX</h4>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Overall P&amp;L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>+X,XX,XXX</h4><small class="text-success" style={{"filter":"blur(5px)"}}>(+xx.xx%)</small>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Pie chart --> */}
                <div class="col-md-2 col-6 ">
                    <div class="d-flex justify-content-center">
                        {/* <!-- <div class="ratio ratio-1x1"> --> */}
                        <canvas id="portfolioPieChart"></canvas>
                        {/* <!-- </div> --> */}
                    </div>
                </div>
                {/* <!-- Legend --> */}
                <div class="col-md-2 col-6 ">
                    <div id="portfolioPieLegend" class="pie-legend ms-md-2 my-3 mt-md-0"></div>
                </div>
            </div>

            <div class="alert alert-primary d-inline-block">
                <small><i class="fa fa-triangle-exclamation"></i> Buy Alert : BUY <span style={{"filter":"blur(5px)"}}>XXXX</span>, <i class="fa fa-briefcase"></i> Qty: <span style={{"filter":"blur(5px)"}}>xxxx</span>, CMP: <span style={{"filter":"blur(5px)"}}>XXX.XX</span></small>
            </div>
            <div class="alert alert-warning d-inline-block">
                <small><i class="fa fa-triangle-exclamation"></i> Sell Alert : SELL <span style={{"filter":"blur(5px)"}}>XXXX</span>, <i class="fa fa-briefcase"></i> Qty: <span style={{"filter":"blur(5px)"}}>xxxx</span>, CMP: <span style={{"filter":"blur(5px)"}}>XXX.XX</span></small>
            </div>

            <div class="d-flex align-items-baseline">
                <h5 class="mb-1 fw-bold">Open Recommendations</h5>
                <small class="text-muted ms-2">(<span style={{"filter":"blur(5px)"}}>XX</span> Units)</small>
            </div>
            <small class="fw-normal text-muted d-block mb-3">As on {moment().format("DD MMM, YYYY")}</small>


            {/* <!-- Table header (desktop) --> */}
            <div class="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                <div class="row g-3">
                    <div class="col-md-3">
                        <span>Scrip</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>Invested & Current Val.</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>Avg. Price & CMP</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>1 Day P&L</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>Total P&L</span>
                    </div>
                </div>
            </div>

            {/* <!-- Rows --> */}
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#4285F4"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> units
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#DB4437"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> units
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#F4B400"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> units
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#0F9D58"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> units
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#AB47BC"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> units
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>                
                    </div>
    </section>
        </Layout>
    )
}
